<template>
    <div style="width:100%;">

        <nav>

            <v-app-bar color="indigo" dark fixed app>
                <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title class="text-uppercase grey--text">
                    <span class="font-weight-light">ISSUES</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>


                <v-btn  v-if="view == 'header'" text color="grey"
                    @click.prevent="newIssue()">
                    <v-icon right>add_box</v-icon>
                </v-btn>

                <v-btn v-if="view == 'header'" text color="grey"
                    @click.prevent="refresh(true)">
                    <v-icon right>refresh</v-icon>
                </v-btn>

                <v-btn text color="grey"
                    @click.prevent="signOut">
                    <span></span>
                    <v-icon right>exit_to_app</v-icon>
                </v-btn>

            </v-app-bar> 

            <NavDraw :drawer="drawer" ></NavDraw>

        </nav>
        <v-container>

            <div v-if="view=='header'">

                <v-layout column>
                    
                    <v-flex v-for="(issue,i) in issues" :key="i">

                        <IssueLine :issue="issue" @clickIssue="viewDetail"></IssueLine>

                    </v-flex>

                </v-layout>

            </div>
            <div v-else-if="view=='detail'">
                <v-layout column>
                    <v-flex>
                        <IssueDet :issue="activeIssue" @close="view = 'header'"></IssueDet>
                    </v-flex>
                </v-layout>
            </div>
            <div v-else-if="view=='new'">
                <v-layout column>
                    <v-flex>
                        <IssueNew @close="closeIssueNew"></IssueNew>
                    </v-flex>
                </v-layout>
                
            </div>

        </v-container>
        <v-overlay :value="overlay">
        <v-progress-circular
            indeterminate
            color="purple"
            size="200"
        ></v-progress-circular>
        </v-overlay>

    </div>
</template>

<script>
import NavDraw from '@/components/NavDraw'
import {mapState, mapActions} from 'vuex'
//import DocFileDetail from './DocFileDetail'
import IssueDet from './IssueDet';
import IssueNew from './IssueNew';
import IssueLine from './IssueLine';

const fb = require('../../firebaseConfig.js')

export default {
    components:{NavDraw,IssueDet,IssueNew,IssueLine},
    data(){
        return {
            drawer:false,
            view:"header",
            searchString:"",
            documents:[],
            issues:[],
            activeIssue:null,
            currentUser:null,
            icons:{
                excel: require('../../assets/excel-icon.png'),
                word: require('../../assets/word-icon.png'),
                pdf: require('../../assets/pdf-icon.png'),
                mindmap: require('../../assets/mindmap-icon.png')
            },
            overlay: false,
        }
    },
    computed:{
        ...mapState(['authUser',
            'brands','departments','issueMaster','issueTypes',
            'issueSubtypes','sections','locations'])
    },
    methods:{
        ...mapActions([]),
        refresh(){
            //this.$store.dispatch('VIDEOS_GET');

            //forceRefresh = !forceRefresh

            if (this.drawer){
                this.drawer = false
            }


            if ( this.currentUser ){
                
                console.log("this.currentUser.userType",this.$store.state.currentUser.userType)

                if (this.currentUser.userType == 'client'){
                    this.fetchIssuesClient()
                }else if (this.currentUser.userType == 'assignee'){
                    this.fetchIssuesAssignee()
                }else{
                    this.fetchIssues()
                }
                /*
                if (this.$store.state.issuesBuffer.issues.length == 0 || forceRefresh){
                    this.$store.state.issuesBuffer.issues = []
                    if (this.currentUser.userType == 'client'){
                        this.fetchIssuesClient()
                    }else if (this.currentUser.userType == 'assignee'){
                        this.fetchIssuesAssignee()
                    }else{
                        this.fetchIssues()
                    }

                }
                else{
                    this.issues = this.$store.state.issuesBuffer.issues
                }
                */

            }
            
        },
        fetchIssues(){

            this.issues = [];
            this.overlay = true
            fb.issuesCollection.where("hdType","==",this.currentUser.hdType).get()
            .then(colIssues=>{
                //console.log("docs",docs)
                this.setIssues(colIssues)
                this.overlay = false
            })

        },
        fetchIssuesClient(){
            this.issues = [];
            this.overlay = true
            fb.issuesCollection.where('raisedByID','==',this.currentUser.userID).get()
            .then(colIssues=>{
                //console.log("docs",docs)
                this.setIssues(colIssues)
                this.overlay = false
            })

        },
        fetchIssuesAssignee(){

            this.issues = [];
            this.overlay = true
            fb.issuesCollection.where('assignedToID','==',this.currentUser.userID).get()
            .then(colIssues=>{

                //console.log("colIssues",colIssues)
                this.setIssues(colIssues);
                this.overlay = false

            })

        },

        setIssues(colIssues){
            let issues = []
            colIssues.forEach(issue=>{
            
                //console.log("issue",issue.data());
                if ( issue.data().status != 'Verified Close'){ 

                    const data = {
                        'id':issue.id,
                        'issueID': issue.data().issueID,
                        'issue':issue.data().issue,
                        'issueType':issue.data().issueType,
                        'issueSubtype':issue.data().issueSubtype,
                        'description':issue.data().description,
                        'department':issue.data().department,
                        'location':issue.data().location,
                        'raisedBy':issue.data().raisedBy,
                        'status':issue.data().status,
                        'brand':issue.data().brand,
                        'assignedTo':issue.data().assignedTo,
                        'assignedToID':issue.data().assignedToID,
                        //'assignedDate':issue.data().assignedDate.toDate(),
                        'assignedBy':issue.data().assignedBy,
                        //'commitmentDate':issue.data().commitmentDate.toDate(),
                        'solution':issue.data().solution,
                        'solutionType':issue.data().solutionType,
                        'solutionDesc':issue.data().solutionDesc,
                        'creationDate':issue.data().creationDate.toDate(),
                        'dateID':issue.data().dateID,
                        'prodOrderNo':issue.data().prodOrderNo,
                        'color':issue.data().color,
                        'productLine':issue.data().productLine,
                        'cutQty':issue.data().cutQty,
                        'affectedQty':issue.data().affectedQty
                    }
                    data.assignedDate = issue.data().assignedDate ? issue.data().assignedDate.toDate() : new Date('1/1/0001')
                    data.commitmentDate = issue.data().commitmentDate ? issue.data().commitmentDate.toDate() : new Date('1/1/0001')
                    data.closeDate = issue.data().closeDate ? issue.data().closeDate.toDate() : new Date('1/1/0001')
                    data.location = issue.data().location ?  issue.data().location : ''
                    data.section = issue.data().section ? issue.data().section : ''
                    data.diagnostic = issue.data().diagnostic ? issue.data().diagnostic : ''
                    data.solutionMethod = issue.data().solutionMethod ? issue.data().solutionMethod : ''

                    issues.push(data);
                }
            });
            
            issues.sort((a,b)=>(a.issueID > b.issueID) ? 1 : -1);
            
            this.issues = issues

            //this.issuesBuffer.issues = [...this.issues]

        },

        newIssue(){
           
            if (this.drawer){
                this.drawer = false
            }

            this.view = "new";
        },
        viewDetail(issue){
            
            if (this.drawer){
                this.drawer = false
            }

            this.view = "detail";
            this.activeIssue = issue;
            //console.log("issue",issue)
        },
        closeIssueNew(val){
            //console.log("val",val)
            
            this.view = 'header'
            if (val && val != ''){
                if ( this.currentUser ){

                    if (this.currentUser.userType == 'client'){
                        this.fetchIssuesClient()
                    }else if (this.currentUser.userType == 'assignee'){
                        this.fetchIssuesAssignee()
                    }else{
                        this.fetchIssues()
                    }

                }
            }

        },
        signOut(){

            //this.issuesBuffer.issues = []

            //clean up state-level data
            this.$store.state.assignees = []
            this.$store.state.departments = []
            this.$store.state.sections = []
            this.$store.state.issueMaster = []
            this.$store.state.issueTypes = []
            this.$store.state.issueSubtypes = []
            this.$store.state.locations = []
            this.$store.state.sections = []
            this.$store.state.assignees = []
            this.$store.state.solutionTypes = []
            this.$store.state.solutions = []
            this.$store.state.solutionMethods = []
            this.$store.state.diagnostics = []
            this.$store.state.diagnosticTypes = []

            this.$store.state.issueStatuses = []
            this.$store.state.problemSources = []
            this.$store.state.accountablePersons = []

            let self = this;
            fb.auth.signOut().then(function() {
                self.$router.push({name:'Login'})
            }).catch(function(error) {
                // An error happened.
                console.log(error.message)
            });

        },

        async checkDropdownLists(){

            if (!this.currentUser){
                return
            }

            //console.log("this.currentUser.hdType",this.$store.state.currentUser.hdType)
            if (this.$store.state.brands.length == 0){
                let brands = []
                let b = await fb.brandsCollection.get()
                //console.log('b',b)
                for(const doc of b.docs){
                    brands.push(doc.data().brand);
                }
                this.$store.state.brands = [...brands]
                //console.log("this.brands",this.$store.state.brands)
            }

            if (this.$store.state.assignees.length == 0){
                let assignees = []
                let b = await fb.assigneesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    assignees.push({
                        assignee:doc.data().assignee,
                        assigneeID:doc.data().assigneeID,
                        department:doc.data().department,
						hdType:doc.data().hdType
                    });
                }
                this.$store.state.assignees = [...assignees]
                //console.log("this.$store.state.assignees",this.$store.state.assignees)
            }

            if (this.$store.state.departments.length == 0){
                let departments = []
                let b = await fb.departmentsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    departments.push({
                        id:doc.id,
                        department:doc.data().department,
                        hdType:doc.data().hdType
                    });
                }
                this.$store.state.departments = [...departments]
                //console.log("this.$store.state.departments",this.$store.state.departments)
            }

            if (this.$store.state.issueMaster.length == 0){
                let issueMaster = []
                let b = await fb.issueMasterCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    const  issue = {
                        id:doc.id,
                        issue:doc.data().issue,
                        issueType:doc.data().issueType,
                        issueSubtype:doc.data().issueSubtype,
                        idx: doc.data().idx
                    }
                    issueMaster.push(issue);
                }
                this.$store.state.issueMaster = [...issueMaster]
                //console.log("this.brands",this.$store.state.brands)
            }

            if (this.$store.state.issueTypes.length == 0){
                let issueTypes = []
                let b = await fb.issueTypesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    issueTypes.push({
                        id:doc.id,
                        issueType:doc.data().issueType
                    });
                }
                this.$store.state.issueTypes = [...issueTypes]
                //console.log("this.issueTypes",this.$store.state.issueTypes)
            }

            if (this.$store.state.issueSubtypes.length == 0){
                let issueSubtypes = []
                let b = await fb.issueSubtypesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    issueSubtypes.push({
                        id:doc.id,
                        subType:doc.data().subType
                    });
                }
                this.$store.state.issueSubtypes = [...issueSubtypes]
                //console.log("this.issueTypes",this.$store.state.issueTypes)
            }

            if (this.$store.state.locations.length == 0){
                let locations = []
                let b = await fb.locationsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    locations.push({
                        id:doc.id,
                        location:doc.data().location,
                        hdType:doc.data().hdType
                    });
                }
                this.$store.state.locations = [...locations]
                //console.log("this.locations",this.$store.state.locations)
            }

            if (this.$store.state.sections.length == 0){
                let sections = []
                let b = await fb.sectionsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
					sections.push({
                        id:doc.id,
                        section:doc.data().section,
                        hdType:doc.data().hdType
                    });
                }
				sections.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.sections = [...sections]
                //console.log("this.sections",this.$store.state.sections)
            }

            if (this.$store.state.assignees.length == 0){
                let assignees = []
                let b = await fb.assigneesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    assignees.push({
                        assignee:doc.data().assignee,
                        assigneeID:doc.data().assigneeID,
                        department:doc.data().department
                    });
                }
                this.$store.state.assignees = [...assignees]
                //console.log("this.assignees",this.$store.state.assignees)
            }

           if (this.$store.state.solutionTypes.length == 0){
                let solutionTypes = []
                let b = await fb.solutionTypesCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    solutionTypes.push({
                        id:doc.id,
                        solutionType:doc.data().solutionType,
                        hdType:doc.data().hdType
                    });
                }
				solutionTypes.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.solutionTypes = [...solutionTypes]
                //console.log("this.solutionTypes",this.$store.state.solutionTypes)
            }

            if (this.$store.state.solutions.length == 0){
                let solutions = []
                let b = await fb.solutionsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    solutions.push({
                        id:doc.id,
                        solution:doc.data().solution,
                        solutionType:doc.data().solutionType,
                        hdType:doc.data().hdType,
                        idx: doc.data().idx
                    });
                }
				solutions.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.solutions = [...solutions]
                //console.log("this.solutions",this.$store.state.solutions)
            }

            if (this.$store.state.solutionMethods.length == 0){
                let solutionMethods = []
                let b = await fb.solutionMethodsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    solutionMethods.push({
                        id:doc.id,
                        method:doc.data().method,
                        hdType:doc.data().hdType
                    });

                }
				solutionMethods.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.solutionMethods = [...solutionMethods]
                //console.log("this.solutionMethods",this.$store.state.solutionMethods)
            }

           if (this.$store.state.diagnostics.length == 0){
                let diagnostics = []
                let b = await fb.diagnosticsCollection.where("hdType","==",this.currentUser.hdType).get()
                //console.log('b',b)
                for(const doc of b.docs){
                    diagnostics.push({
                        id:doc.id,
                        diagnostic:doc.data().diagnostic,
						diagnosticType:doc.data().diagnosticType,
                        hdType:doc.data().hdType
                    });
                }
				diagnostics.sort((a,b)=>(a > b) ? 1 : -1);
                this.$store.state.diagnostics = [...diagnostics]
                //console.log("this.diagnostics",this.$store.state.diagnostics)
            }


        },

        async fetchCurrentUser(){

            if (!this.$store.state.authUser){
                return
            }

            let b = await fb.usersCollection.where('userID','==',this.$store.state.authUser.uid).get()
            //console.log('b',b)
            let user = null
            for(const doc of b.docs){
                user = doc.data();
            }
            //console.log("user",user)
            this.currentUser = user

            this.$store.state.currentUser = user
            localStorage.setItem('currentUser',JSON.stringify(user))

        }

    },
    mounted(){

        console.log("Issues mounted!");

    },
    created(){
        console.log("Issues Created")

        this.headerView = true;

        //console.log("this.$store.state.currentUser",this.$store.state.currentUser)
        
        console.log("this.$store.state.authUser",this.$store.state.authUser)
        this.fetchCurrentUser()

        console.log("this.$store.state.currentUser",this.$store.state.currentUser)
        if ( !this.$store.state.currentUser || this.$store.state.currentUser.userID == '' ){

            let currentUser = JSON.parse(localStorage.getItem('currentUser'))
            //console.log("currentUser from localStorage",currentUser)
            this.currentUser = currentUser
            if (currentUser){
                this.$store.state.currentUser = {...currentUser}
                this.checkDropdownLists()
                this.refresh()
            }
            
        }else{
            this.currentUser = this.$store.state.currentUser
            this.checkDropdownLists()
            this.refresh()
        }


    },

}
</script>

<style  scoped>

.row-header .col-header {
    background-color:black;
    color:white;
    font-weight: bold;
    text-align: center;
    padding-bottom: 5px;
    padding-top: 5px;
    margin-top: 10px;
    margin-bottom: 5px;
}

.row-header .col-header2 {
    background-color:lightgray;
    color:black;
    font-weight: bold;
    font-size:medium;
    text-align: center;
}

.file-icon{
    width:40px;
    height: 40px;
    max-width: 40px;
    max-height: 40px;
}

.dv-clear{
    cursor: pointer;
}
.label-text{
    font-weight: bold;
}
.dv-message{
    font-weight: bold;
    font-size: 1.2rem;
    color:blue;
    margin-left: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.errorMessage{
    color:red;
    border: 2px solid red;
    padding: 10px;
}

.emp-clear-status{
    color:blue;
    border: 2px solid red;
    font-weight: bold;
    padding: 5px;
}
</style>